
import { ErrorNode, ParseTreeListener, ParserRuleContext, TerminalNode } from "antlr4ng";


import { TextExpressionRootContext } from "./FrendsExpressionParser.js";
import { CsExpressionRootContext } from "./FrendsExpressionParser.js";
import { TextExpressionContext } from "./FrendsExpressionParser.js";
import { InterpolatedExpressionContext } from "./FrendsExpressionParser.js";
import { EachStatementContext } from "./FrendsExpressionParser.js";
import { IfStatementContext } from "./FrendsExpressionParser.js";
import { IfBranchContext } from "./FrendsExpressionParser.js";
import { ElseIfBranchContext } from "./FrendsExpressionParser.js";
import { ElseBranchContext } from "./FrendsExpressionParser.js";
import { CsExpressionContext } from "./FrendsExpressionParser.js";
import { NonEmptyCsExpressionContext } from "./FrendsExpressionParser.js";
import { ReferenceContext } from "./FrendsExpressionParser.js";
import { VarRefContext } from "./FrendsExpressionParser.js";
import { TriggerRefContext } from "./FrendsExpressionParser.js";
import { ProcessRefContext } from "./FrendsExpressionParser.js";
import { EnvRefContext } from "./FrendsExpressionParser.js";
import { CertRefContext } from "./FrendsExpressionParser.js";
import { ResultNodeRefContext } from "./FrendsExpressionParser.js";
import { ResultRefContext } from "./FrendsExpressionParser.js";
import { ThisRefContext } from "./FrendsExpressionParser.js";
import { IndexRefContext } from "./FrendsExpressionParser.js";
import { SourceRefContext } from "./FrendsExpressionParser.js";
import { CsTextContext } from "./FrendsExpressionParser.js";
import { StringContext } from "./FrendsExpressionParser.js";


/**
 * This interface defines a complete listener for a parse tree produced by
 * `FrendsExpressionParser`.
 */
export class FrendsExpressionParserListener implements ParseTreeListener {
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.textExpressionRoot`.
     * @param ctx the parse tree
     */
    enterTextExpressionRoot?: (ctx: TextExpressionRootContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.textExpressionRoot`.
     * @param ctx the parse tree
     */
    exitTextExpressionRoot?: (ctx: TextExpressionRootContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.csExpressionRoot`.
     * @param ctx the parse tree
     */
    enterCsExpressionRoot?: (ctx: CsExpressionRootContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.csExpressionRoot`.
     * @param ctx the parse tree
     */
    exitCsExpressionRoot?: (ctx: CsExpressionRootContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.textExpression`.
     * @param ctx the parse tree
     */
    enterTextExpression?: (ctx: TextExpressionContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.textExpression`.
     * @param ctx the parse tree
     */
    exitTextExpression?: (ctx: TextExpressionContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.interpolatedExpression`.
     * @param ctx the parse tree
     */
    enterInterpolatedExpression?: (ctx: InterpolatedExpressionContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.interpolatedExpression`.
     * @param ctx the parse tree
     */
    exitInterpolatedExpression?: (ctx: InterpolatedExpressionContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.eachStatement`.
     * @param ctx the parse tree
     */
    enterEachStatement?: (ctx: EachStatementContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.eachStatement`.
     * @param ctx the parse tree
     */
    exitEachStatement?: (ctx: EachStatementContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.ifStatement`.
     * @param ctx the parse tree
     */
    enterIfStatement?: (ctx: IfStatementContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.ifStatement`.
     * @param ctx the parse tree
     */
    exitIfStatement?: (ctx: IfStatementContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.ifBranch`.
     * @param ctx the parse tree
     */
    enterIfBranch?: (ctx: IfBranchContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.ifBranch`.
     * @param ctx the parse tree
     */
    exitIfBranch?: (ctx: IfBranchContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.elseIfBranch`.
     * @param ctx the parse tree
     */
    enterElseIfBranch?: (ctx: ElseIfBranchContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.elseIfBranch`.
     * @param ctx the parse tree
     */
    exitElseIfBranch?: (ctx: ElseIfBranchContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.elseBranch`.
     * @param ctx the parse tree
     */
    enterElseBranch?: (ctx: ElseBranchContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.elseBranch`.
     * @param ctx the parse tree
     */
    exitElseBranch?: (ctx: ElseBranchContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.csExpression`.
     * @param ctx the parse tree
     */
    enterCsExpression?: (ctx: CsExpressionContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.csExpression`.
     * @param ctx the parse tree
     */
    exitCsExpression?: (ctx: CsExpressionContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.nonEmptyCsExpression`.
     * @param ctx the parse tree
     */
    enterNonEmptyCsExpression?: (ctx: NonEmptyCsExpressionContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.nonEmptyCsExpression`.
     * @param ctx the parse tree
     */
    exitNonEmptyCsExpression?: (ctx: NonEmptyCsExpressionContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.reference`.
     * @param ctx the parse tree
     */
    enterReference?: (ctx: ReferenceContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.reference`.
     * @param ctx the parse tree
     */
    exitReference?: (ctx: ReferenceContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.varRef`.
     * @param ctx the parse tree
     */
    enterVarRef?: (ctx: VarRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.varRef`.
     * @param ctx the parse tree
     */
    exitVarRef?: (ctx: VarRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.triggerRef`.
     * @param ctx the parse tree
     */
    enterTriggerRef?: (ctx: TriggerRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.triggerRef`.
     * @param ctx the parse tree
     */
    exitTriggerRef?: (ctx: TriggerRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.processRef`.
     * @param ctx the parse tree
     */
    enterProcessRef?: (ctx: ProcessRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.processRef`.
     * @param ctx the parse tree
     */
    exitProcessRef?: (ctx: ProcessRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.envRef`.
     * @param ctx the parse tree
     */
    enterEnvRef?: (ctx: EnvRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.envRef`.
     * @param ctx the parse tree
     */
    exitEnvRef?: (ctx: EnvRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.certRef`.
     * @param ctx the parse tree
     */
    enterCertRef?: (ctx: CertRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.certRef`.
     * @param ctx the parse tree
     */
    exitCertRef?: (ctx: CertRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.resultNodeRef`.
     * @param ctx the parse tree
     */
    enterResultNodeRef?: (ctx: ResultNodeRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.resultNodeRef`.
     * @param ctx the parse tree
     */
    exitResultNodeRef?: (ctx: ResultNodeRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.resultRef`.
     * @param ctx the parse tree
     */
    enterResultRef?: (ctx: ResultRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.resultRef`.
     * @param ctx the parse tree
     */
    exitResultRef?: (ctx: ResultRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.thisRef`.
     * @param ctx the parse tree
     */
    enterThisRef?: (ctx: ThisRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.thisRef`.
     * @param ctx the parse tree
     */
    exitThisRef?: (ctx: ThisRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.indexRef`.
     * @param ctx the parse tree
     */
    enterIndexRef?: (ctx: IndexRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.indexRef`.
     * @param ctx the parse tree
     */
    exitIndexRef?: (ctx: IndexRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.sourceRef`.
     * @param ctx the parse tree
     */
    enterSourceRef?: (ctx: SourceRefContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.sourceRef`.
     * @param ctx the parse tree
     */
    exitSourceRef?: (ctx: SourceRefContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.csText`.
     * @param ctx the parse tree
     */
    enterCsText?: (ctx: CsTextContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.csText`.
     * @param ctx the parse tree
     */
    exitCsText?: (ctx: CsTextContext) => void;
    /**
     * Enter a parse tree produced by `FrendsExpressionParser.string`.
     * @param ctx the parse tree
     */
    enterString?: (ctx: StringContext) => void;
    /**
     * Exit a parse tree produced by `FrendsExpressionParser.string`.
     * @param ctx the parse tree
     */
    exitString?: (ctx: StringContext) => void;

    visitTerminal(node: TerminalNode): void {}
    visitErrorNode(node: ErrorNode): void {}
    enterEveryRule(node: ParserRuleContext): void {}
    exitEveryRule(node: ParserRuleContext): void {}
}

